import { useEffect, useState } from "react";
import { friendsApi, friendlyError } from "@/lib/api";
import { Button, Card, ErrorText, Field, PageLoader } from "@/components/ui";

export function Wallet() {
  const [addr, setAddr] = useState<string | null>(null);
  const [value, setValue] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  const [saved, setSaved] = useState(false);

  useEffect(() => {
    friendsApi
      .wallet()
      .then((r) => {
        setAddr(r.address);
        setValue(r.address || "");
      })
      .catch(() => setAddr(""));
  }, []);

  if (addr === null) return <PageLoader />;

  const valid = /^T[1-9A-HJ-NP-Za-km-z]{33}$/.test(value.trim());
  const save = async () => {
    if (!valid || busy) return;
    setBusy(true);
    setError("");
    setSaved(false);
    try {
      const r = await friendsApi.setWallet(value.trim());
      setAddr(r.address);
      setValue(r.address);
      setSaved(true);
      setTimeout(() => setSaved(false), 2000);
    } catch (e) {
      setError(friendlyError(e, "Не удалось сохранить адрес."));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="space-y-3 pt-2">
      <div>
        <div className="text-xl font-bold">Кошелёк выплат</div>
        <p className="mt-1 text-sm text-white/45">
          Единый TRC20-адрес — на него выводится крипта всех ваших друзей (удержание 3 USDT за вывод).
        </p>
      </div>
      <Card className="space-y-3">
        <Field
          label="Адрес TRC20"
          value={value}
          onChange={(e) => setValue(e.target.value)}
          placeholder="T..."
        />
        {value.trim() && !valid && <ErrorText>Неверный формат TRC20-адреса.</ErrorText>}
        <ErrorText>{error}</ErrorText>
        <Button className="w-full" loading={busy} disabled={!valid || value.trim() === (addr || "")} onClick={save}>
          {saved ? "Сохранено ✓" : "Сохранить"}
        </Button>
      </Card>
    </div>
  );
}
